module.exports = __webpack_public_path__ + "static/media/knapsack.62049a62.svg";